import { Button } from 'components/lib';
import Navigation from 'components/Navigation';
import AppStoreContext from 'contexts/AppStoreContext';
import Immutable from 'immutable';
import * as React from 'react';
import { Page } from 'records/Page';
import { ProcessingStatusList } from 'records/ProcessingStatus';
import { uploadDocument } from 'services/documentService';
import { getPages } from 'services/pageService';
import { getProcessingStatuses } from 'services/processingStatusService';

// THIS PAGE CAN LIKELY BE REMOVED, BUT LEAVING HERE FOR REFERENCE

const CustomEditorPage: React.FC = () => {
  const { state: appState } = React.useContext(AppStoreContext);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [processingStatuses, setProcessingStatuses] =
    React.useState<ProcessingStatusList>(Immutable.List());
  const [isReady, setIsReady] = React.useState(false);
  const [page, setPage] = React.useState<Page | null>(null);
  const [processingRequestId, setProcessingRequestId] = React.useState<{
    prid: string;
    docId: string;
    handle: number;
  } | null>(null);

  const handleBrowseClick = () => {
    const fileInput = inputRef.current;

    if (fileInput) {
      fileInput.click();
    }
  };

  React.useEffect(() => {
    if (isReady && processingRequestId) {
      console.log('getting page');
      const getPage = async () => {
        const pages = await getPages(processingRequestId.docId);
        console.log('got pages', pages.toJS());
        setPage(pages.first(null));
      };

      getPage();
    }
  }, [isReady]);

  React.useEffect(() => {
    processingStatuses.forEach((processingStatus) => {
      if (processingStatus.processingRequestid === processingRequestId?.prid) {
        console.log(processingStatus.status);
        if (processingStatus.status === 'Ready for Review') {
          setIsReady(true);
          window.clearInterval(processingRequestId?.handle);
        }
      }
    });
  }, [processingStatuses]);

  const handleFileSelect = async () => {
    const fileInput = inputRef.current;

    if (fileInput && fileInput.files && fileInput.files.length) {
      const files = [...Array.from(fileInput.files)];
      const res = await uploadDocument(
        appState.selectedProject,
        files[0],
        'SUBMITTAL'
      );

      if (!res) {
        console.log('Bad times');
        return;
      }

      const { docId, processingRequestId: _processingRequestId } = res;

      const timeoutHandle = window.setInterval(async () => {
        const statuses = await getProcessingStatuses(
          appState.selectedProject,
          true
        );
        setProcessingStatuses(statuses);
      }, 1000);

      setProcessingRequestId({
        prid: _processingRequestId,
        handle: timeoutHandle,
        docId,
      });
    }
  };

  return (
    <Navigation>
      <Button onClick={handleBrowseClick} variant="primary">
        Browse Files
      </Button>
      <input
        type="file"
        ref={inputRef}
        hidden
        accept="application/pdf"
        onChange={handleFileSelect}
      />
      {/* {isReady && page && processingRequestId && (
        // TBD - refactor to use ECSEditor if desired
        // <DocViewer
        //   doc={Doc.deserialize({
        //     ...new Doc().serialize(),
        //     documentid: processingRequestId.docId,
        //   })}
        //   page={page}
        //   pageIndex={0}
        //   showToolbar
        //   viewOnly={false}
        // />
      )} */}
    </Navigation>
  );
};

export default CustomEditorPage;
